<template>
    <div>
        <el-button type="primary" size="mini" plain @click="getData">
            <span class="el-icon-edit-outline">添加购房顾问</span>
        </el-button>
        <el-dialog
            title="购房顾问"
            :visible.sync="showdialog"
            width="1100px"
            v-dialogDrag
            append-to-body>
            <div class="base-warp">
                <div class="head">
                    <el-form :model="form" ref="form" label-width="80px" :inline="true" size="mini">
                        <el-form-item label="姓名">
                            <el-input v-model="form.keyword"></el-input>
                        </el-form-item>
                        <el-form-item label="电话">
                            <el-input type="number" v-model="form.telephone"></el-input>
                        </el-form-item>
                        <el-form-item>
                            <el-button type="primary" @click="confirm">搜索</el-button>
                        </el-form-item>
                    </el-form>
                </div>
                <div class="table-box">
                    <el-table 
                    :data="tableData" 
                    ref="multipleTable"
                    border 
                    @selection-change="handleSelectionChange"
                    :header-cell-style="{background:'#f7f7f7',color:'#999', textAlign: 'center', fontWeight: 'normal'}">
                        <el-table-column type="selection" label="选择" width="55"></el-table-column>
                        <el-table-column type="index" label="序号" width="60"></el-table-column>
                        <el-table-column prop="ltpic" label="头像" >
                            <template slot-scope="s">
                                <el-avatar icon="el-icon-user-solid" :size="40" shape="circle" :src="JSON.parse(s.row.ltpic)[0]" fit="fill"></el-avatar>
                            </template>
                        </el-table-column>
                        <el-table-column prop="name" label="姓名" ></el-table-column>
                        <el-table-column prop="telphone" label="手机" ></el-table-column>
                        <el-table-column prop="tags" label="标签" >
                            <template slot-scope="s">
                                <div class="tags" v-if="s.row.tags">
                                    <div class="tag" v-for="(tag, ind) in JSON.parse(s.row.tags)" :key="ind">{{tag}}</div>
                                </div>
                            </template>
                        </el-table-column>
                        <el-table-column prop="zixunlen" label="咨询人数" ></el-table-column>
                    </el-table>
                    <div style="margin-top: 20px; text-align: right;">
                        <el-button type="primary" @click="add">确定选择</el-button>
                        <el-button @click="toggleSelection()">取消选择</el-button>
                    </div>
                </div>
                <el-pagination class="page-tion"
                    @current-change="currentChange"
                    layout="prev, pager, next"
                    :page-size="pagesize"
                    :total="total" background>
                </el-pagination>
            </div>
        </el-dialog>
        
    </div>
</template>

<script>
export default {
    data() {
        return {
            showdialog: false,
            form: {
                keyword: '',
                telephone: '',
            },
            tableData: [],
            multipleSelection: [],
            pageNo: 1,
            pagesize: 6,
            total: 0,
        }
    },
    methods: {
        getData() {
            this.showdialog = true;
            var params = {
                name: this.form.keyword,
                telephone: this.form.telephone,
                status: '03',
                pageNo: this.pageNo,
                pagesize: this.pagesize,
            }
            this.$api.getConsultants(params).then(
                data=>{
                    let {list, total} = data;
                    this.tableData = list;
                    this.total = total;
                }
            )
        },
        add() {
            this.showdialog = false;
            if (this.multipleSelection.length>0) {
                for (var broker of this.multipleSelection){
                    if (typeof broker.ltpic == 'string') broker.ltpic = JSON.parse(broker.ltpic);
                    if (typeof broker.tags == 'string') broker.tags = JSON.parse(broker.tags);
                }
            }
            this.$emit('getBroker', this.multipleSelection);
        },
        confirm() {
            this.pageNo = 1;
            this.getData();
        },
        toggleSelection(rows) {
            if (rows) {
                rows.forEach(row => {
                    this.$refs.multipleTable.toggleRowSelection(row);
                });
            } else {
                this.$refs.multipleTable.clearSelection();
            }
            this.showdialog = false;
        },
        handleSelectionChange(val) {
            this.multipleSelection = val;
        },
        currentChange(page) {
            this.pageNo = page;
            this.getData();
        },
    },
}
</script>

<style lang="scss" scoped>

</style>